<template>
  <div class="wp-editor" dir="rtl">
    <div class="wp-editor__top">
      <h1 class="wp-editor__heading">{{ status_form == 0 ? 'افزودن نوشته' : 'ویرایش نوشته' }}</h1>
      <CButton v-if="status_form != 0" size="sm" color="secondary" variant="outline" @click="$router.push('/dashboard/news/add-news')">افزودن نوشته جدید</CButton>
    </div>

    <div class="wp-editor__layout">
      <!-- ======= main column ======= -->
      <div class="wp-editor__main">
        <div class="wp-title-wrap">
          <label class="sr-only" for="post-title">عنوان نوشته</label>
          <input id="post-title" v-model="title" class="wp-title" type="text" placeholder="عنوان را اینجا وارد کنید" autocomplete="off" :class="{ 'is-invalid': triedSave && !title.trim() }">
        </div>
        <div class="wp-permalink">
          <span class="wp-permalink__label">پیوند یکتا:</span>
          <template v-if="!editSlug">
            <a :href="postUrl" target="_blank" rel="noopener" dir="ltr" class="wp-permalink__url">{{ siteBase }}/blog/<b>{{ favorite_url || slugPreview || '…' }}</b></a>
            <button type="button" class="wp-btn-link" @click="startSlugEdit">ویرایش</button>
          </template>
          <template v-else>
            <span dir="ltr" class="wp-permalink__url">{{ siteBase }}/blog/</span>
            <input v-model="slugDraft" class="wp-permalink__input" dir="auto" @keydown.enter.prevent="saveSlug" @keydown.esc="editSlug = false">
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="saveSlug">تأیید</button>
            <button type="button" class="wp-btn-link" @click="editSlug = false">لغو</button>
          </template>
        </div>

        <div class="wp-content">
          <editorjs v-if="loaded_page"
                    editor_id="add_new_editor"
                    :first_content.sync="content_json"
                    :content_json.sync="content_json"
                    :content_text.sync="content_text"
                    :content_html.sync="content_html"
          />
          <div v-else class="wp-content__sk" aria-hidden="true"><div class="sk sk-bar"></div><div class="sk sk-area"></div></div>
          <div class="wp-content__foot">تعداد واژه‌ها: {{ fa(wordCount) }}<span v-if="post_data.updated_at"> · آخرین ویرایش: {{ get_date_time(post_data.updated_at) }}</span></div>
        </div>

        <WpBox title="سئو" store-key="post-seo">
          <div class="form-group">
            <label class="wp-label" for="seo-title">عنوان سئو <span class="text-danger">*</span></label>
            <input id="seo-title" v-model="seo_title" class="form-control" type="text" :placeholder="title || 'عنوان در نتایج گوگل'">
            <SeoProgress :min_perfect="50" :max_perfect="60" :string="seo_title"/>
          </div>
          <div class="form-group">
            <label class="wp-label" for="seo-kw">کلیدواژه کانونی</label>
            <input id="seo-kw" v-model="keyword" class="form-control" type="text" placeholder="مثلاً: خرید کولر گازی">
          </div>
          <div class="form-group mb-0">
            <label class="wp-label" for="seo-desc">توضیحات متا <span class="text-danger">*</span></label>
            <textarea id="seo-desc" v-model="seo_summary" class="form-control" rows="3" placeholder="خلاصه‌ای جذاب که زیر عنوان در نتایج جستجو نمایش داده می‌شود"></textarea>
            <SeoProgress :min_perfect="120" :max_perfect="150" :string="seo_summary"/>
          </div>
        </WpBox>

        <WpBox title="سئوی پیشرفته و Schema" store-key="post-schema">
          <SeoBox ref="seo"
                  entity-type="post"
                  :entity-id="status_form"
                  :name="title"
                  :slug="favorite_url"
                  url-prefix="/blog/"
                  :content-html="content_html"
                  :title.sync="seo_title"
                  :description.sync="seo_summary"
                  :keyword.sync="keyword"
                  default-schema="BlogPosting"
          />
        </WpBox>


        <WpBox title="پیشنهاد لینک‌سازی داخلی" store-key="post-links" :open="false">
          <BlogLinkSuggestion :content="content_html" :keyword="keyword" :title="title"/>
        </WpBox>
      </div>

      <!-- ======= sidebar ======= -->
      <aside class="wp-editor__side">
        <WpBox title="انتشار" store-key="post-publish">
          <div class="wp-pub-actions">
            <CButton size="sm" color="secondary" variant="outline" :disabled="saving" @click="saveDraft">ذخیره پیش‌نویس</CButton>
            <CButton size="sm" color="secondary" variant="outline" :disabled="!favorite_url && status_form == 0" @click="go_show_blog()">پیش‌نمایش</CButton>
          </div>
          <ul class="wp-pub-list">
            <li><span class="wp-pub-ico">●</span> وضعیت:
              <select v-model.number="post_status" class="wp-inline-select" aria-label="وضعیت">
                <option :value="1">منتشر شده</option>
                <option :value="2">پیش‌نویس</option>
              </select>
            </li>
            <li><span class="wp-pub-ico">◉</span> نمایانی: <b>{{ post_status === 1 ? 'عمومی' : 'خصوصی (فقط مدیران)' }}</b></li>
            <li class="wp-pub-date"><span class="wp-pub-ico">▣</span> زمان انتشار:
              <date-picker
                  v-model="publish_date"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  input-format="YYYY-MM-DD HH:mm:ss"
                  alt-format="YYYY-MM-DD HH:mm:ss"
                  display-format="jYYYY/jMM/jDD HH:mm"
                  placeholder="فوری"
              />
            </li>
            <li v-if="post_data.updated_at"><span class="wp-pub-ico">✎</span> آخرین ویرایش: <b>{{ get_date_time(post_data.updated_at) }}</b></li>
          </ul>
          <div class="wp-pub-footer">
            <span v-if="triedSave && missing.length" class="wp-pub-missing">{{ missing.join('، ') }} را تکمیل کنید</span>
            <CButton color="primary" class="wp-pub-main" :disabled="saving" @click="publish">
              <CSpinner v-if="saving" size="sm" class="ml-1"/>
              {{ status_form == 0 ? (post_status === 1 ? 'انتشار' : 'ذخیره') : 'به‌روزرسانی' }}
            </CButton>
          </div>
        </WpBox>

        <WpBox title="دسته‌ها" store-key="post-cats">
          <template #badge><span v-if="triedSave && !value_category.length" class="text-danger small">الزامی</span></template>
          <div class="wp-cats">
            <CategoryChecklist v-if="options_category.length" v-model="value_category" :nodes="options_category"/>
            <p v-else class="text-muted mb-0">دسته‌ای تعریف نشده است.</p>
          </div>
          <router-link to="/dashboard/news/categories/0" class="wp-btn-link d-inline-block mt-2">+ مدیریت دسته‌ها</router-link>
        </WpBox>

        <WpBox title="برچسب‌ها" store-key="post-tags">
          <treeselect
              v-model="value_tags"
              :multiple="true"
              :async="true"
              :load-options="load_tags"
              placeholder="جستجو و افزودن برچسب"
              :normalizer="normalizer_tags"
          />
          <small class="text-muted d-block mt-1">برچسب‌ها را جستجو و انتخاب کنید.</small>
        </WpBox>

        <WpBox title="تصویر شاخص" store-key="post-image">
          <ImageSelector label=""
                         :media_id.sync="file"
                         default_archive="blog_post"
                         :preview-image="previewImage"
          />
          <button v-if="hasImage" type="button" class="wp-btn-link text-danger mt-2" @click="removeImage">حذف تصویر شاخص</button>
          <small v-if="triedSave && !hasImage" class="text-danger d-block mt-1">تصویر شاخص الزامی است</small>
        </WpBox>

        <WpBox v-if="status_form != 0" title="یادداشت مدیر" store-key="post-notes" :open="false">
          <div v-for="comment in admin_comments" :key="comment.id" class="wp-note">
            <p class="mb-1">{{ comment.summary }}</p>
            <small class="text-muted">{{ get_date_time(comment.created_at) }} · {{ comment.admin_name || (comment.user && comment.user.name) || '' }}</small>
          </div>
          <textarea v-model="comment_summary" class="form-control mb-2" rows="2" placeholder="یادداشت داخلی (فقط مدیران)"></textarea>
          <CButton size="sm" color="secondary" :disabled="!comment_summary.trim()" @click="add_post_admin_comment()">افزودن یادداشت</CButton>
        </WpBox>
      </aside>
    </div>
  </div>
</template>

<script>
import editorjs from "@/views/includes/editorjs.vue";
import axios from "@/api/http";
import SeoBox from "@/views/includes/SeoBox.vue";

import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import BlogLinkSuggestion from "./BlogLinkSuggestion.vue";
import WpBox from "@/views/includes/WpBox.vue";
import CategoryChecklist from "@/views/includes/CategoryChecklist.vue";

const FA = "۰۱۲۳۴۵۶۷۸۹"
const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000)
}


export default {
  name: 'Login',
  components: {
    SeoBox,
    Treeselect,
    BlogLinkSuggestion,
    WpBox,
    CategoryChecklist,
    editorjs
    // ckeditor: CKEditor.component
  },
  data() {

    return {
      post_data:{},
      admin_comments:[],
      comment_summary:'',
      editor: null,
      loaded_page: false,
      content_json: {},
      content_text: '',
      content_html: '',
      value_category: [],
      value_tags: [],
      value_keywords: [],
      // define options
      image_upload: '',
      options_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },

      load_tags({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            axios.post('/api/admin/blog/search_blog_tags', {
              search: searchQuery,

            }).then(function (response) {
              options = response.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });

          })
        }
      },
      normalizer_tags(node) {
        return {
          id: node.title,
          label: node.title,
        }
      },
      // editor: ClassicEditor,
      editorData: '',
      title: '',
      favorite_url: '',
      publish_date: '',
      seo_title: '',
      keyword: '',
      summary: '',
      seo_summary: '',
      tags: '',
      file: [],

      previewImage: null,
      image: '',

      details: [],
      status_form: 0,
      post_status: 1,
      saving: false,
      triedSave: false,
      editSlug: false,
      slugDraft: '',

    }
  },
  mounted() {

    this.get_categories();
    if (this.$route.params.post_id != null) {
      this.status_form = this.$route.params.post_id;
      this.get_post_info();
      this.get_admin_comments();

    } else {
      this.loaded_page = true
    }

  },
  computed: {
    siteBase() { return String(localStorage.getItem('web_address') || '').replace(/\/+$/, '') },
    slugPreview() { return String(this.title || '').trim().replace(/\s+/g, '-').replace(/[^\w\u0600-\u06FF-]/g, '').slice(0, 80) },
    postUrl() { return this.siteBase + '/blog/' + (this.favorite_url || this.slugPreview) },
    wordCount() { return String(this.content_text || '').trim().split(/\s+/).filter(Boolean).length },
    hasImage() { return Array.isArray(this.file) ? !!this.file[0] : !!this.file },
    missing() {
      const m = []
      if (!String(this.title || '').trim()) m.push('عنوان')
      if (!String(this.seo_title || '').trim()) m.push('عنوان سئو')
      if (!String(this.seo_summary || '').trim()) m.push('توضیحات متا')
      if (!this.value_category.length) m.push('دسته')
      if (!this.hasImage) m.push('تصویر شاخص')
      return m
    },
  },
  watch: {
    '$route.params.post_id': function () {
      this.get_categories();
    },
    // 'editorData': function () {
    //   let tmp = document.createElement("DIV");
    //   tmp.innerHTML = this.editorData;
    //   this.content_text = tmp.textContent || tmp.innerText || "";
    //
    //   this.content_html = this.editorData;
    // },

  },
  methods: {
    fa(n) { return String(n).replace(/\d/g, (d) => FA[d]) },
    startSlugEdit() { this.slugDraft = this.favorite_url || this.slugPreview; this.editSlug = true },
    saveSlug() { this.favorite_url = String(this.slugDraft || '').trim().replace(/\s+/g, '-'); this.editSlug = false },
    removeImage() { this.file = []; this.previewImage = null },
    publish() {
      this.triedSave = true
      if (this.missing.length) { this.showError(this.missing.join('، ') + ' را تکمیل کنید'); return }
      this.login()
    },
    saveDraft() {
      this.post_status = 2
      this.triedSave = true
      if (!String(this.title || '').trim()) { this.showError('عنوان را وارد کنید'); return }
      this.login()
    },
    async handleAIContent(data) {
      console.log("data ai",data)
      const { blocks } = data;

      // پاک کردن محتوای قبلی
      // await this.editor.blocks.clear();
this.loaded_page = false;
      this.content_json = { "time": 1782542462932, "blocks": blocks, "version": "2.28.2" }

      // اضافه کردن بلوک‌های جدید
      // blocks.forEach(block => {
      //   this.content_json.push(block.type, block.data);
      // });
      var self= this
      setTimeout(function (){
        self.loaded_page = true;

      },500)
      this.showSuccess('محتوای مقاله با موفقیت تولید شد!');
    },
    showSuccess(msg) {
      this.$toast?.success(msg) || alert(msg);
    },

    showError(msg) {
      this.$toast?.error(msg) || alert('خطا: ' + msg);
    },
    go_show_blog() {
      window.open(this.postUrl, "_blank");
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/blog/get_categories_with_children', formData, {}).then(function (response) {
        // console.log("cats is "+response.data.groups);
        // console.log("cats is "+items);

        var content_cats = response.data;

        // items = content_cats.orders;
        self.options_category = content_cats.orders;
        // console.log("cats is "+items);
        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append('post_id', self.status_form);
      axios.post('/api/admin/blog/post_info', formData, {}).then(function (response) {
        var post_data = response.data;

        self.file = [post_data.post.image_id];
        self.previewImage = post_data.post.image;
        post_data.post.categories.forEach((val) => {
          self.value_category.push(val.category_id);
        });
        post_data.post.tags.forEach((val) => {
          self.value_tags.push(val.tag.title.title);
        });

        // self.value_category = post_data.post.categories;
        //  self.options_=post_data.post.tags;
        // self.value_keywords=post_data.post.keywords;
        self.title = post_data.post.title.title;
        self.favorite_url = post_data.post.title.slug;
        self.publish_date = post_data.post.publish_date;
        self.content_json = JSON.parse(post_data.post.title.description);

        self.seo_summary = post_data.post.title.short_description;
        self.seo_title = post_data.post.title.seo_title;
        self.keyword = post_data.post.title.keyword;
        self.loaded_page = true
        self.post_data = post_data.post
        self.post_status = post_data.post.status === 2 ? 2 : 1

        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },
    get_admin_comments() {


      var self = this;
      var formData = new FormData();
      formData.append('id', self.status_form);
      axios.post('/api/admin/blog/get_post_admin_comments', formData, {}).then(function (response) {
       self.admin_comments = response.data
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },


    login() {
      let self = this;
      if (self.saving) return;
      self.saving = true;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/admin/blog/insert_post";
      } else {
        url = "/api/admin/blog/update_post";
        formData.append('post_id', this.status_form)

      }

      formData.append('post_image', (Array.isArray(this.file) ? this.file[0] : this.file) || '')
      formData.append('status', this.post_status)
      formData.append('cat_list', this.value_category)
      formData.append('tags', this.value_tags)
      formData.append('name', this.title)
      formData.append('url', this.favorite_url)
      formData.append('publish_date', this.publish_date)
      formData.append('text', JSON.stringify(this.content_json))
      formData.append('meta_desc', this.seo_summary)
      formData.append('meta_title', this.seo_title)
      formData.append('keyword', this.keyword)

      axios.post(url, formData, {}).then(async (res) => {
        if (res.data && res.data.error == 0 && self.$refs.seo) await self.$refs.seo.save(self.status_form == 0 ? (res.data.id || res.data.post_id) : self.status_form);
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0 && res.data.error==0) {
          self.name = '';
          self.mobile = '';
          self.email = '';
          self.description = '';
          self.password = '';
          self.selected_group = '0';
          self.permissions = [];
          const newId = res.data.id || res.data.post_id
          if (newId) self.$router.replace('/dashboard/news/edit-news/' + newId); else self.$router.push('/dashboard/news/all-news')
          // self.$router.go(-1)
        }
      }).catch(function (error) {
        self.$root.modal_component.show_api_response_modals({data:{error:1,msg:'خطا در ثبت'}});

        console.log(error);
      }).finally(() => { self.saving = false; });

    },
    add_post_admin_comment() {
      let self = this;
      const formData = new FormData()
      let url;

        url = "/api/admin/blog/add_post_admin_comment";
        formData.append('id', this.status_form)


      formData.append('summary', this.comment_summary)


      axios.post(url, formData, {}).then(() => {
       self.comment_summary = '';
       self.get_admin_comments();
      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>

<style scoped>
.wp-editor { max-width: 1400px; margin: 0 auto; color: #1d2327; }
.wp-editor__top { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.wp-editor__heading { margin: 0; font-size: 22px; font-weight: 600; }
.wp-editor__layout { display: grid; grid-template-columns: minmax(0, 1fr) 300px; gap: 20px; align-items: start; }
.wp-editor__side { position: sticky; top: 16px; max-height: calc(100vh - 32px); overflow-y: auto; padding-bottom: 8px; }
@media (max-width: 991.98px) {
  .wp-editor__layout { grid-template-columns: 1fr; }
  .wp-editor__side { position: static; max-height: none; overflow: visible; }
}
.wp-title { width: 100%; border: 0; border-bottom: 1px solid transparent; background: transparent; padding: 6px 2px; font-size: 28px; font-weight: 700; line-height: 1.4; color: #1d2327; outline: none; }
.wp-title:focus { border-bottom-color: var(--accent, #2563eb); }
.wp-title::placeholder { color: #a7aaad; font-weight: 400; }
.wp-title.is-invalid { border-bottom-color: #d63638; }
.wp-permalink { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; margin: 4px 2px 14px; font-size: 13px; color: #50575e; }
.wp-permalink__label { font-weight: 600; }
.wp-permalink__url { color: #2271b1; word-break: break-all; }
.wp-permalink__input { min-width: 200px; border: 1px solid #8c8f94; border-radius: 3px; padding: 2px 6px; font-size: 13px; }
.wp-btn-link { background: none; border: 0; padding: 0; color: #2271b1; font-size: 13px; text-decoration: underline; cursor: pointer; }
.wp-content { background: #fff; border: 1px solid #dcdcde; border-radius: 4px; margin-bottom: 16px; }
.wp-content ::v-deep .tiptap-editor-toolbar { position: sticky; top: 0; z-index: 5; margin: 0; border: 0; border-bottom: 1px solid #dcdcde; border-radius: 4px 4px 0 0; background: #f6f7f7; }
.wp-content ::v-deep .tiptap-editor-holder,
.wp-content ::v-deep .editorjs-holder { min-height: 480px; border-radius: 0; padding: 12px 18px; }
.wp-content__foot { border-top: 1px solid #f0f0f1; padding: 6px 12px; font-size: 12px; color: #646970; background: #f6f7f7; }
.wp-content__sk { padding: 12px; }
.sk { background: linear-gradient(90deg, #eef0f3 25%, #f6f7f9 37%, #eef0f3 63%); background-size: 400% 100%; animation: sk 1.4s ease infinite; border-radius: 4px; }
.sk-bar { height: 36px; margin-bottom: 12px; }
.sk-area { height: 420px; }
@keyframes sk { 0% { background-position: 100% 50% } 100% { background-position: 0 50% } }
.wp-label { font-weight: 600; font-size: 13px; margin-bottom: 4px; }
.wp-pub-actions { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 10px; }
.wp-pub-list { list-style: none; padding: 0; margin: 0 0 8px; }
.wp-pub-list li { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; padding: 6px 0; }
.wp-pub-ico { color: #8c8f94; width: 14px; text-align: center; }
.wp-pub-date ::v-deep .vpd-main { flex: 1; min-width: 160px; }
.wp-inline-select { border: 1px solid #c3c4c7; border-radius: 3px; padding: 1px 6px; font-size: 13px; font-weight: 600; background: #fff; }
.wp-pub-footer { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; margin: 4px -14px -12px; padding: 10px 14px; border-top: 1px solid #dcdcde; background: #f6f7f7; }
.wp-pub-main { margin-inline-start: auto; min-width: 110px; }
.wp-pub-missing { font-size: 11px; color: #d63638; }
.wp-cats { max-height: 260px; overflow-y: auto; border: 1px solid #f0f0f1; padding: 6px 10px; border-radius: 3px; }
.wp-note { border-inline-start: 3px solid #dcdcde; padding: 4px 10px; margin-bottom: 8px; }
</style>
